export default "__VITE_ASSET__CMRpNV$L__"